<template>
  <div class="d-flex align-items-center flex-nowrap text-center w-100 prev-next-container">
    <div class="prev-next-wrapper opacity-50 cursor-pointer" @click="$emit('change', prev.datetime)">
      <p class="text-5xl text-md-6xl mb-1">
        <span v-if="showGateAndLine">{{prev['gate'] + '.' + prev['line']}}</span>
        <span v-else>{{prev[type]}}</span>
      </p>
      <p>{{ $t('charts.transit.previous') }}</p>
    </div>

    <div>
      <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#191C23" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#2F2F2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#434343" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div class="font-500">
      <p class="text-4xl text-md-6xl mb-1">
        <span v-if="showGateAndLine">{{current['gate'] + '.' + current['line']}}</span>
        <span v-else>{{current[type]}}</span>
      </p>
      <p>{{ $t('charts.transit.current') }}</p>
    </div>

    <div>
      <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#191C23" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#2F2F2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 13.5L7 7.5L0.999999 1.5" stroke="#434343" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div class="prev-next-wrapper opacity-50 cursor-pointer" @click="$emit('change', next.datetime)">
      <p class="text-5xl text-md-6xl mb-1">
        <span v-if="showGateAndLine">{{next['gate'] + '.' + next['line']}}</span>
        <span v-else>{{next[type]}}</span>
      </p>
      <p>{{ $t('charts.transit.next') }}</p>
    </div>
  </div>
</template>

<script>
export default{
  props:{
    type: {
      type: String,
      default: 'gate'
    },
    current: Object,
    next: Object,
    prev: Object,
    showGateAndLine:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.prev-next-container {
  gap: 24px;

  @media (min-width: 768px) {
    gap: 32px;
  }
}

.prev-next-wrapper {
  transition-timing-function: ease-in-out;
  transition-duration: 150ms;

  &:hover {
    opacity: 1;
  }
}
</style>
